import { render, staticRenderFns } from "./gajiPokok.vue?vue&type=template&id=ca4081c0"
import script from "./gajiPokok.vue?vue&type=script&lang=js"
export * from "./gajiPokok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports